module.exports = __webpack_public_path__ + "static/media/progman_28.91742779.ico";